import React from 'react';

import { Row, RowCell, RowHeaderCell } from '../atoms/row.tsx';
import { ContentCellData } from '../cell-variants/types.ts';

import { ContentCell } from './content-cell.tsx';

interface ContentRowProps {
	row: ContentCellData[];
	rowKey: string | number;
	columnTitles: string[];
	columnIds: string[];
	groupId: string;
}

export const ContentRow: React.FC<ContentRowProps> = (props: ContentRowProps) => {
	const { row, rowKey, columnTitles, columnIds, groupId } = props;
	const rowHeaderId = `tblRow_${rowKey}`;
	return (
		<Row key={rowKey}>
			{row.map((cell, cellIndex) =>
				cellIndex === 0 ? (
					<RowHeaderCell key={cellIndex} id={rowHeaderId}>
						<ContentCell isRowHeader={true} cellData={cell} />
					</RowHeaderCell>
				) : (
					<RowCell
						key={cellIndex}
						// @ts-expect-error -- columnTitle is a valid prop but TypeScript can't infer it through HTMLAttributes
						columnTitle={columnTitles[cellIndex]}
						headers={[groupId, columnIds[cellIndex], rowHeaderId].filter(Boolean).join(' ')}
					>
						<ContentCell cellData={cell} />
					</RowCell>
				),
			)}
		</Row>
	);
};
